export enum DatabaseLanguageCodes {
	DE = "de",
	EN = "en",
	FR = "fr",
	NLD = "nl",
	RUS = "ru",
	ESP = "es",
	CAT = "cat",
	UKR = "ua",
	PL = "pl"
}

export const Languages = [
	{
		language: "Deutsch",
		label: DatabaseLanguageCodes.DE.toUpperCase(),
		databaseLanguageCode: DatabaseLanguageCodes.DE,
		url: "de",
		hreflang: "de"
	},
	{
		language: "Englisch",
		label: DatabaseLanguageCodes.EN.toUpperCase(),
		databaseLanguageCode: DatabaseLanguageCodes.EN,
		url: "en",
		hreflang: "en"
	},
	{
		language: "Französisch",
		label: DatabaseLanguageCodes.FR.toUpperCase(),
		databaseLanguageCode: DatabaseLanguageCodes.FR,
		url: "fr",
		hreflang: "fr"
	},
	{
		language: "Niederländisch",
		label: DatabaseLanguageCodes.NLD.toUpperCase(),
		databaseLanguageCode: DatabaseLanguageCodes.NLD,
		url: "nl",
		hreflang: "nl"
	},
	{
		language: "Russisch",
		label: DatabaseLanguageCodes.RUS.toUpperCase(),
		databaseLanguageCode: DatabaseLanguageCodes.RUS,
		url: "ru",
		hreflang: "ru"
	},
	{
		language: "Spanisch",
		label: DatabaseLanguageCodes.ESP.toUpperCase(),
		databaseLanguageCode: DatabaseLanguageCodes.ESP,
		url: "es",
		hreflang: "es"
	},
	{
		language: "Katalanisch",
		label: DatabaseLanguageCodes.CAT.toUpperCase(),
		databaseLanguageCode: DatabaseLanguageCodes.CAT,
		url: "ca",
		hreflang: "ca"
	}
	// {
	// 	language: "Ukrainisch",
	// 	label: DatabaseLanguageCodes.UKR.toUpperCase(),
	// 	databaseLanguageCode: DatabaseLanguageCodes.UKR,
	// 	url: "ua",
	// 	hreflang: "ua"
	// }
	// { language: "Polnisch", label: DatabaseLanguageCodes.PL.toUpperCase(), url: DatabaseLanguageCodes.PL }
];
